export default __webpack_public_path__ + "static/media/Logo_x3.655f1ca8.png";